import React, { Component } from "react";

import DoctorPhotoView from "./DoctorPhotoView";
import {
  showSuccessNotification,
  bytesToSize,
  showInfoNotification,
  strings,
  openNotificationWithIcon
} from "../../../helpers";
import {
  updateClinicDoctor,
  getPresignedUrl,
  uploadImageToS3
} from "../../../services";
import DeleteConfirmationModal from "./DeleteConfirmationModal";

export default class DoctorPhotoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewVisible: false,
      previewImage: "",
      clinicId: localStorage.getItem("clinic_id"),
      uploading: false,
      apiArray: [],
      showDeleteModal: false
    };
  }

  /**
   * @func handleCancel
   * @desc it calncles the preview mode
   */
  handleCancel = () => this.setState({ previewVisible: false });

  /**
   * @func handlePreview
   * @param file
   * @desc it shows the image preview
   *
   */
  handlePreview = file => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true
    });
  };

  /**
   * @func customRequest
   * @param file
   * @param onProgress
   * @desc it makes the request to upload image
   */
  customRequest = async ({ file, onProgress }) => {
    if (!this.state.maxLimitReached) {
      this.setState({ uploading: true });
      // this.props.toggleUploading();
      const checkFileSize = bytesToSize(file.size);
      const fileSize = parseInt(checkFileSize, 10);
      const fileSizeString = checkFileSize.replace(/\d/g, "");

      if (fileSizeString === "MB") {
        if (fileSize > 5) {
          return;
        }
      }

      if (fileSizeString === "KB") {
        if (fileSize > 5000) {
          return;
        }
      }

      const { clinicId } = this.state;
      const { doctorObj } = this.props;
      let tempArr = [];
      const forApiArray = [];
      const uniqueTimeStamp = new Date().getTime();

      const keyValue = `${process.env.REACT_APP_DOCTOR_PROFILE_IMAGES_S3_FOLDER}/doctor_${doctorObj.doctor.id}/${uniqueTimeStamp}_${file.name}`;

      const params = {
        files: [
          {
            bucket: process.env.REACT_APP_S3_BUCKET,
            file_path: keyValue
          }
        ]
      };

      let response = await getPresignedUrl(params);
      let fileUrl = null;

      if (response && response.data && response.data.success) {
        fileUrl = response.data.data.ps_urls[0];
        const uploadResponse = await uploadImageToS3(fileUrl, file.type, file);
        if (uploadResponse && uploadResponse.status === 200) {
          const uploadedS3FileUrl = `https://${process.env.REACT_APP_S3_BUCKET}.s3.${process.env.REACT_APP_S3_REGION}.amazonaws.com/${keyValue}`;
          const uniqueId = 1;
          const obj = {
            uid: uniqueId,
            name: `${uniqueTimeStamp}.png`,
            status: "done",
            url: uploadedS3FileUrl
          };

          tempArr.push(obj);
          this.setState({ fileList: tempArr }, () => {
            tempArr.map(element => {
              forApiArray.push(element.url);
            });
            this.setState({ apiArray: forApiArray, status: "uploaded" });
            this.props.getImageData(forApiArray);
          });

          // update backend
          const photoObj = {
            doctor_details: {
              clinic_doctor_photo: this.state.apiArray[0]
            }
          };
          updateClinicDoctor(clinicId, doctorObj.id, photoObj)
            .then(response => {
              if (response.data && response.data.success) {
                this.setState({ uploading: false });
              } else {
                this.setState({ uploading: false });
                openNotificationWithIcon(
                  "error",
                  "Error while uploading",
                  "Server error"
                );
              }
            })
            .catch(() => {
              this.setState({ uploading: false });
            });
        }
      }
    }
  };

  /**
   * @func handleChange
   * @param fileList
   * @desc it returns all the data of images
   */
  handleChange = data => {
    if (!this.state.maxLimitReached) {
      const checkFileSize = bytesToSize(data.file.size);

      const fileSize = parseInt(checkFileSize, 10);
      const fileSizeString = checkFileSize.replace(/\d/g, "");

      if (fileSizeString === "MB") {
        if (fileSize > 5) {
          showInfoNotification(
            "Image size warning",
            "Image size cant be more than 5MB"
          );
          return;
        }
      }

      if (fileSizeString === "KB") {
        if (fileSize > 5000) {
          showInfoNotification(
            "Image size warning",
            "Image size cant be more than 5MB"
          );
          return;
        }
      }

      const { fileList, file } = data;
      const { status } = file;
      const forApiArray = [];

      this.setState({ fileList, status }, () => {
        fileList.map(element => {
          const forApi = {
            id: element.id,
            photo_url: element.url,
            cover_photo: element.cover_photo || false,
            url: element.url
          };
          forApiArray.push(forApi);
        });
        this.setState({ apiArray: forApiArray });
      });
    }
  };

  /**
   * @func onRemove
   * @param file
   * @desc it removes the selected file from the final array of photos
   */
  onRemove = () => {
    this.setState({ showDeleteModal: true });
  };

  toggleDeleteModal = () => {
    this.setState(prevState => {
      return {
        showDeleteModal: !prevState.showDeleteModal
      };
    });
  };

  handleDeletePhoto = () => {
    const { clinicId } = this.state;
    const { doctorObj } = this.props;
    const photoObj = {
      doctor_details: {
        clinic_doctor_photo: null
      }
    };
    this.setState({ uploading: true });
    updateClinicDoctor(clinicId, doctorObj.id, photoObj)
      .then(response => {
        if (response.data && response.data.success) {
          this.props.getImageData([]);
          this.setState({ uploading: false, showDeleteModal: false });
        } else {
          this.setState({ uploading: false, showDeleteModal: false });
          openNotificationWithIcon(
            "error",
            "Error while deleting",
            "Server Error"
          );
        }
      })
      .catch(() => {
        this.setState({ uploading: false, showDeleteModal: false });
      });
  };

  render() {
    const {
      previewVisible,
      previewImage,
      uploading,
      showDeleteModal
    } = this.state;
    const { displayPhotos, doctorObj } = this.props;
    return (
      <React.Fragment>
        <DoctorPhotoView
          onRemove={this.onRemove}
          customRequest={this.customRequest}
          handleChange={this.handleChange}
          handleCancel={this.handleCancel}
          previewVisible={previewVisible}
          previewImage={previewImage}
          fileList={displayPhotos}
          handlePreview={this.handlePreview}
          handleSubmit={this.handleSubmit}
          uploading={uploading}
          checkMaxLimit={this.checkMaxLimit}
          doctorObj={doctorObj}
        />

        {showDeleteModal && (
          <DeleteConfirmationModal
            showDeleteModal={showDeleteModal}
            toggleDeleteModal={this.toggleDeleteModal}
            handleDeletion={this.handleDeletePhoto}
            isProcessing={uploading}
            modalTitle={"Delete photo"}
            modalMessage={"Are you sure you want to delete photo?"}
          />
        )}
      </React.Fragment>
    );
  }
}
